import React from 'react';

import styles from 'pages/LiveClassroom/components/StudentsOverview/style.module.scss';
import {
  STATUS_TO_COLOR_MAPPER,
  STATUS_TO_ICON_MAPPER
} from 'pages/LiveClassroom/constants';

const StudentBlock = ({ student, onClick }) => {
  const { name, status } = student;
  const color = STATUS_TO_COLOR_MAPPER[status];
  const icon = STATUS_TO_ICON_MAPPER[status];

  return (
    <div
      className={styles.block}
      style={{ backgroundColor: color }}
      onClick={() => onClick(student)}
    >
      <div className={styles.icon}>{icon}</div>
      <span className={styles.name}>{name}</span>
    </div>
  );
};

export default StudentBlock;
